import React, { useEffect, useState } from "react";
import { useAuth } from "component/UseAuth";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import { PDFDownloadLink } from "@react-pdf/renderer";
import axios from "axios";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import MyReportmutasiRek from "component/utils/MyReportmutasiRek";
import LapKasRekDatatables from "component/akunting/report/laporan-kas-rek/LapKasRekDatatables";

function LaporanKasRek() {
  const { user } = useAuth();
  const [isShow, setisShow] = useState(false);
  const [data, setData] = useState([]);
  const [date, setDate] = useState();

  useEffect(() => {
    document.title = "Green Hill Kemuning | Report KAS Rekening";
    window.scrollTo(0, 0);
  }, []);

  const handleShowReport = async (date) => {
    try {
      const reg_desc = user?.company;
      const dateObj = new Date(date);
      const formattedDate = `${String(dateObj.getDate()).padStart(2, "0")}-${String(dateObj.getMonth() + 1).padStart(2, "0")}-${dateObj.getFullYear()}`;
      
      const res = await axios.post(
        `${process.env.REACT_APP_API}/proses-mutasi-rekening`,
        { reg_desc, tanggal: formattedDate }
      );

      if (res.data.msg_code === "200" || res.data.msg_code === "201") {
        await showReport(date);
      } else {
        showError(res.data.msg_desc || "Gagal Menampilkan data.");
      }
    } catch (err) {
      console.error(err);
      showError("Terjadi kesalahan saat menampilkan data.");
    }
  };

  const showReport = async (date) => {
    try {
      const reg_desc = user?.company;
      const dateObj = new Date(date);
      const formattedDate = `${String(dateObj.getDate()).padStart(2, "0")}-${String(dateObj.getMonth() + 1).padStart(2, "0")}-${dateObj.getFullYear()}`;
      const formattedDateDown = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, "0")}-${String(dateObj.getDate()).padStart(2, "0")}`;
      const showReport = await axios.post(
        `${process.env.REACT_APP_API}/tampil-mutasi-rekening`,
        { reg_desc, tanggal: formattedDate }
      );

      if (showReport.data.msg_code === "200" || showReport.data.msg_code === "201" ) {
        setData(showReport.data.data);
        setDate(formattedDateDown);
        setisShow(true);
        if (Array.isArray(showReport.data.data) && showReport.data.data.length > 0) {
          showSuccess("Data berhasil ditampilkan!");
        } else {
          showSuccess("Data Tidak ada!");
        }
      } else {
        showError(showReport.data.msg_desc || "Gagal menampilkan.");
      }
    } catch (error) {
      console.error("Error tampil mutasi rekening:", error);
      showError("Terjadi kesalahan saat menampilkan mutasi rekening.");
    }
  };

  const handlePrint = () => {
    if (!isShow) return;
    window.print();
  };

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Sidebar />

        <div className="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
          <Navbar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <div className="row px-4">
                <div className="card shadow p-3">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="card-title m-0">LAPORAN KAS (REK)</h5>
                      <div className="d-flex gap-3 align-items-center">
                        {isShow && data.length > 0 && (
                          <PDFDownloadLink
                            document={<MyReportmutasiRek data={data} saldo_date={date} userBy={user?.name} />}
                            fileName={`laporan-mutasirek-${date}.pdf`}
                          >
                            {({ loading }) => (
                              <i
                                className={`bx ${loading ? "bx-loader-circle bx-spin" : "bxs-download"}`}
                                title="Download PDF"
                                style={{ fontSize: 30, cursor: "pointer", color: "green" }}
                              />
                            )}
                          </PDFDownloadLink>
                        )}
                      </div>
                    </div>

                    <LapKasRekDatatables data={data} onShow={handleShowReport} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
      </div>
    </div>
  );
}

export default LaporanKasRek;
